<template>
    <div class="contact">
         <widget-options>
            <widget-button
                v-if="$store.getters.can( 'audit', 'updateContact' )"
                class="capitalize"
                :settings="{
                    action: () => toggleUpdateContactModal(),
                    label: 'updateContact'
                }"
            />
            <widget-button
                v-if="$store.getters.can( 'audit', 'resolve' )"
                class="capitalize"
                :settings="{
                    action: () => toggleModal(),
                    label: 'duplicateContactCall'
                }"
            />
            <widget-button
                v-if="$store.getters.can( 'audit', 'resolve' )"
                class="capitalize"
                :settings="{
                    action: () => toggleAssociateRecordingModal(),
                    label: 'associateRecording'
                }"
            />
        </widget-options>
        <modal
            v-if="modal.showDuplicateCall"
            :form="{
                class: 'call__modal',
                settings: {
                    typeOfPreparation: 'resolve'
                }
            }"
            :customSettings="{
                color: 'green',
                class: 'call__modal__content',
                button: {
                    label: 'confirmEvaluation'
                },
                show: {
                    infoSection: false
                }
            }"
            :executeCloseAction="!loading"
            :preventReset="true"
            @close="toggleModal()"
            :key="modal.showDuplicateCall" >
            <template #modal__header >
                <h2 class="call__modal__header">{{ $t('global.callEvaluation') }}</h2>
            </template>
            <template #modal__body >
                <div class="cal__modal__body">
                    <div class="call__modal__icons display--flex">
                        <button-with-icon
                            :icon="{
                                component: () =>
                                    import( /* webpackChunkName: 'IconPositive' */ '@/components/bundles/layout/images/icons/IconPositive' ),
                                    class: `
                                        call__modal__icon
                                        call__modal__icon--green
                                        pointer
                                        ${ call.type === 'successful' ? 'call__modal__icon--green--active' : '' }
                                    `
                            }"
                            class="call__modal__icons__button"
                            :action="{
                                execute: true,
                                function: chooseTypeOfState
                            }"
                        />
                        <button-with-icon
                            :icon="{
                                component: () =>
                                    import( /* webpackChunkName: 'IconReschedule' */ '@/components/bundles/layout/images/icons/IconReschedule' ),
                                class: `
                                    call__modal__icon
                                    call__modal__icon--reschedule
                                    pointer
                                    ${ call.type === 'rescheduling' ? 'call__modal__icon--reschedule--active' : '' }
                                `
                            }"
                            class="call__modal__icons__button"
                            :action="{
                                execute: true,
                                function: chooseTypeOfState,
                                param: 'rescheduling'
                            }"
                        />
                        <button-with-icon
                            :icon="{
                                component: () =>
                                    import( /* webpackChunkName: 'IconNegative' */ '@/components/bundles/layout/images/icons/IconNegative' ),
                                class: `
                                    call__modal__icon
                                    call__modal__icon--red
                                    pointer
                                    ${ call.type === 'unsuccessful' ? 'call__modal__icon--red--active' : '' }
                                `
                            }"
                            class="call__modal__icons__button"
                            :action="{
                                execute: true,
                                function: chooseTypeOfState,
                                param: 'unsuccessful'
                            }"
                        />
                    </div>
                    <transition v-if="showCall.rescheduling" name="call__modal--transition" appear >
                        <div class="call__modal__rescheduling">
                            <base-field
                                class="call__modal__input"
                                :settings="{
                                    label: { class: 'field__label--hide', text: $t('global.rescheduleTo') },
                                    input: {
                                        component: 'InputCalendar',
                                        name: 'rescheduleTo',
                                        id: 'rescheduleTo',
                                        targetClass: 'field__input--default ty+pography--default color--default',
                                        value: getDateISO,
                                        browserAutocomplete: 'off',
                                        dynamicData: {
                                            configs: {
                                                mode: 'dateTime',
                                                is24hr: true,
                                                minDate: getDate,
                                                format: dateFormat,
                                                hideInput: true
                                            },
                                            isInline: true
                                        },
                                        isMissing: errors.missing.rescheduleTo,
                                        fileValidation: 'isAfterCertainDate',
                                        errors: [{
                                            type: 'isAfter', warning: $t('error.isAfter', { date: $t('global.beginDate') })
                                        }],
                                        errorOnSubmit: {
                                            show: errors.api.rescheduleTo ? true : false,
                                            messages: errors.api.rescheduleTo
                                        },
                                        validationParameter: getDate,
                                        noListener: true
                                    },
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="call__modal__input call__modal__input--new-contact"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.newContact') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'newContactValue',
                                        name: 'newContactValue',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: '',
                                        browserAutocomplete: 'newContact',
                                        errorOnSubmit: {
                                            show: errors.api.newContactValue ? true : false,
                                            messages: errors.api.newContactValue
                                        },
                                        noListener: true
                                    },
                                    allowFilling: true
                                }"
                            />
                        </div>
                    </transition>
                    <base-field
                        class="call__modal__input"
                        :settings="{
                            label: { class: 'call__modal__label capitalize', text: $t('global.selectACause') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'stateId',
                                name: 'stateId',
                                type: 'text',
                                value: drop.value,
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: errors.missing.stateId,
                                dynamicData: {
                                    data: call.states.drop
                                },
                                noListener: true
                            },
                            allowFilling: drop.active
                        }"
                    />
                </div>
            </template>
        </modal>
        <modal
            v-if="updateContacts.modal.show"
            :form="{
                class: 'modal--update-contact',
                settings: {
                    typeOfPreparation: 'updateContacts'
                      }
            }"
            :customSettings="{
                color: 'green',
                class: 'modal--update-contact__content',
                button: {
                    label: 'confirm'
                      },
                show: {
                    infoSection: false
                }
            }"
            :executeCloseAction="!loading"
            :preventReset="true"
            @close="toggleUpdateContactModal()"
            :key="updateContacts.modal.show" >
            <template #modal__header >
                <h2 class="modal--update-contact__header">{{ $t('global.updateContact') }}</h2>
            </template>
            <template #modal__body >
                <div class="modal--update-contact__body">
                    <base-field
                        class="modal--update-contact__type"
                        :settings="{
                            label: { class: 'modal--update-contact__label capitalize', text: $t('global.type') },
                            input: {
                                component: 'InputAutocomplete',
                                id: 'type',
                                name: 'type',
                                type: 'text',
                                value: drop.value,
                                targetClass: 'field__input--default typography--default color--default',
                                browserAutocomplete: 'off',
                                isRequired: true,
                                isMissing: errors.missing.type,
                                dynamicData: {
                                    data: updateContacts.types
                                },
                                noListener: true
                            },
                            allowFilling: true
                        }"
                    />
                </div>
                <base-field
                    v-if="payload.type === 'email'"
                    class="modal--update-contact__email"
                    :settings="{
                        label: { class: 'capitalize', text: $t('global.email') },
                        input: {
                            component: 'InputBasic',
                            id: 'email',
                            name: 'email',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'email',
                            isRequired: true,
                            isMissing: errors.missing.email,
                            fileValidation: 'basicEmail',
                            errors: [{
                                type: 'email', warning: $t('error.email')
                            }],
                            errorOnSubmit: {
                                show: errors.api.email ? true : false,
                                messages: errors.api.email
                            }
                        },
                        isEdition,
                        allowFilling: true
                    }"
                />
                <base-field
                    v-if="payload.type === 'phone'"
                    class="modal--update-contact__phone"
                    :settings="{
                        label: { class: 'capitalize', text: $t('global.phone') },
                        input: {
                            component: 'InputBasic',
                            id: 'phone',
                            name: 'phone',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'phone',
                            isRequired: true,
                            isMissing: errors.missing.phone,
                            fileValidation: 'basicPhone',
                            errors: [{
                                type: 'decimal', warning: $t('error.onlyDigits')
                            }],
                            errorOnSubmit: {
                                show: errors.api.phone ? true : false,
                                messages: errors.api.phone
                            }
                        },
                        isEdition,
                        allowFilling: true
                    }"
                />
            </template>
        </modal>
        <modal
            v-if="modal.associateRecording.show"
            id="associateModal"
            :form="{
                class: 'call__modal',
                settings: {
                    typeOfPreparation: 'associateRecordings'
                }
            }"
            :customSettings="{
                color: 'green',
                class: 'modal--associate-recordings__content',
                button: {
                    label: 'confirmAssociation'
                },
                show: {
                    infoSection: false,
                    actions: modal.associateRecording.type === 'recordings'
                    || ( modal.associateRecording.type === 'file' && payload.hasOwnProperty('resources') )
                }
            }"
            :executeCloseAction="!loading"
            :preventReset="true"
            @close="toggleAssociateRecordingModal()"
            :key="modal.associateRecording.show" >
            <template #modal__header >
                <h2 class="call__modal__header">{{ $t('global.associateRecording') }}</h2>
            </template>
            <template #modal__body >
                <div class="call__modal__body">
                    <div
                        v-if="!modal.associateRecording.type || modal.associateRecording.type === 'file'"
                        class="modal--associate-recordings__options"
                    >
                        <div class="modal--associate-recordings__options__title">{{ $t('global.howDoYouWantToAssociateRecording') }}</div>
                        <div class="modal--associate-recordings__options__content display--flex">
                            <base-card-option
                                :class="{ 'card--import-contacts__option--selected': payload.hasOwnProperty('resources') }"
                                :templates="{ have: false }"
                            >
                                <template #card__icon >
                                    <base-field
                                        class="modal--associate-recordings__options__resources"
                                        :settings="{
                                            label: { class: 'field__label--hide' },
                                            input: {
                                                component: 'InputFile',
                                                id: 'resources',
                                                name: 'resources',
                                                type: 'file',
                                                value: '',
                                                targetClass: 'field__input--default typography--default color--default',
                                                browserAutocomplete: 'off',
                                                formatsAllowed: [ '.mp3', '.wav' ]
                                            },
                                            isEdition: false,
                                            allowFilling: true
                                        }"
                                    />
                                </template>
                                <template #card__title >
                                    {{ $t(`global.importAudio`) }} <span class="typography--light">(.mp3, .wav)</span>
                                </template>
                            </base-card-option>
                            <base-card-option
                                class="pointer"
                                @click.native="modal.associateRecording.type = 'recordings'"
                            >
                                <template #card__icon >
                                    <icon-select-entities/>
                                </template>
                                <template #card__title >
                                    {{ $t(`global.selectRecording`) }}
                                </template>
                            </base-card-option>
                        </div>
                    </div>
                    <template  v-if="modal.associateRecording.type">
                        <base-field
                            class="call__modal__input associate--call"
                            :class="{ 'associate--call__file': modal.associateRecording.type === 'file' }"
                            :settings="{
                                label: { class: 'call__modal__label capitalize', text: $t('global.call') },
                                input: {
                                    component: 'InputAutocomplete',
                                    id: 'call',
                                    name: 'call',
                                    type: 'text',
                                    value: drop.value,
                                    targetClass: 'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: true,
                                    isMissing: errors.missing.call,
                                    dynamicData: {
                                        data: callsDrop
                                    },
                                    noListener: true
                                },
                                allowFilling: drop.active
                            }"
                        />
                        <div v-if="associateCall && callHasAudio( associateCall )"
                            class="call__modal__warning color--red"
                        >
                            {{ $t('warning.callHasAssociatedAudio') }}
                        </div>
                    </template>
                    <template  v-if="modal.associateRecording.type && modal.associateRecording.type === 'recordings'">
                        <base-field
                            v-if="associateCall"
                            class="call__modal__input associate--recording"
                            :settings="{
                                label: { class: 'call__modal__label capitalize', text: $t('global.recordingToAssociate') },
                                input: {
                                    component: 'InputAutocompleteAudios',
                                    id: 'recording',
                                    name: 'recording',
                                    type: 'text',
                                    value: drop.value,
                                    targetClass: 'field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    isRequired: true,
                                    isMissing: errors.missing.recording,
                                    audio: audioUrl,
                                    dynamicData: {
                                        data: recordingsDrop
                                    },
                                    noListener: true
                                },
                                allowFilling: associateCall
                            }"
                        />
                    </template>
                </div>
            </template>
        </modal>
        <base-form class="contact__form">
            <base-card class="contact__request">
                <template #card__title >
                    {{ $t('global.personContactDetails') }}
                </template>
                <template #card__body >
                    <div class="contact__body display--grid page--single__grid">
                        <base-field-with-url
                            v-if="$route.meta.isAdd"
                            class="contact__body__campaign"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.campaign') },
                                input: {
                                    ...( !isEdition && {
                                        component: 'InputAutocomplete',
                                        id: 'campaignId',
                                        type: 'text',
                                        targetClass: 'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.campaignId,
                                        dynamicData: {
                                            data: [ ...campaigns ],
                                            ordering: order.loading
                                        },
                                        errorOnSubmit: {
                                            show: errors.api.campaignId ? true : false,
                                            messages: errors.api.campaignId
                                        }
                                    }),
                                    name: 'campaignId',
                                    value: campaign.name
                                },
                                allowFilling: !isEdition && permissions.allowFilling
                            }"
                            :anchor="{
                                url: `/campaigns/${campaignId}`,
                                disable: !campaignId,
                                see: $store.getters.can( 'campaigns', 'see' ),
                                translationKey: 'viewCampaign'
                            }"
                        />
                        <base-field
                            class="contact__body__holder"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.holder') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'holder',
                                    name: 'holder',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: requestPerson.name,
                                    browserAutocomplete: 'holder',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.holder,
                                    errorOnSubmit: {
                                        show: errors.api.holder ? true : false,
                                        messages: errors.api.holder
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="contact__body__contact-person"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.contactPerson') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'contactPerson',
                                    name: 'contactPerson',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: requestPerson.contactPerson,
                                    browserAutocomplete: 'contactPerson',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.contactPerson,
                                    errorOnSubmit: {
                                        show: errors.api.contactPerson ? true : false,
                                        messages: errors.api.contactPerson
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="contact__body__tin"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.taxpayerIdentificationNumber') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'taxpayerIdentificationNumber',
                                    name: 'taxpayerIdentificationNumber',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: requestPerson.taxpayerIdentificationNumber,
                                    browserAutocomplete: 'taxpayerIdentificationNumber',
                                    isRequired: false,
                                    isMissing: errors.missing.taxpayerIdentificationNumber,
                                    errorOnSubmit: {
                                        show: errors.api.taxpayerIdentificationNumber ? true : false,
                                        messages: errors.api.taxpayerIdentificationNumber
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="contact__body__nin"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.nationalIdentificationNumber') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'nationalIdentificationNumber',
                                    name: 'nationalIdentificationNumber',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: requestPerson.nationalIdentificationNumber,
                                    browserAutocomplete: 'nationalIdentificationNumber',
                                    isRequired: false,
                                    isMissing: errors.missing.nationalIdentificationNumber,
                                    errorOnSubmit: {
                                        show: errors.api.nationalIdentificationNumber ? true : false,
                                        messages: errors.api.nationalIdentificationNumber
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="contact__body__birthdate"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.birthdate') },
                                input: {
                                    component: 'InputCalendar',
                                    id: 'birthdate',
                                    name: 'birthdate',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: requestPerson.birthdate,
                                    browserAutocomplete: 'off',
                                    isRequired: false,
                                    isMissing: errors.missing.birthdate,
                                    errorOnSubmit: {
                                        show: errors.api.birthdate ? true : false,
                                        messages: errors.api.birthdate
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <template v-if="!isEdition">
                            <base-field
                                class="contact__body__email"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.email') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'email',
                                        name: 'email',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: '',
                                        browserAutocomplete: 'email',
                                        isRequired: false,
                                        isMissing: errors.missing.email,
                                        fileValidation: 'basicEmail',
                                        errors: [{
                                            type: 'email', warning: $t('error.email')
                                        }],
                                        errorOnSubmit: {
                                            show: errors.api.email ? true : false,
                                            messages: errors.api.email
                                        }
                                    },
                                    isEdition,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="contact__body__phone"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.phone') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'phone',
                                        name: 'phone',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: '',
                                        browserAutocomplete: 'phone',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.phone,
                                        fileValidation: 'basicPhone',
                                        errors: [{
                                            type: 'decimal', warning: $t('error.onlyDigits')
                                        }],
                                        errorOnSubmit: {
                                            show: errors.api.phone ? true : false,
                                            messages: errors.api.phone
                                        }
                                    },
                                    isEdition,
                                    allowFilling: true
                                }"
                            />
                        </template>
                        <div
                            :class="{ 'contact__body__contacts__first': index === 0 }"
                            class="contact__body__contacts" v-for="( contact, index ) in requestPerson.contacts" :key="index">
                            <base-field
                                v-if="requestPerson.contacts"
                                class="contact__body__contacts__field"
                                :settings="{
                                    label: { class: 'capitalize', text: $t(`contacts.${ contact.type }`) },
                                    input: {
                                        name: 'contactOption',
                                        class: 'field__input--default typography--default color--default',
                                        value: contact.value,
                                    },
                                    allowFilling: false
                                }"
                            />
                        </div>
                        <base-field
                            v-if="isEdition"
                            class="contact__body__receptiondate"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.receptionDate') },
                                input: {
                                    name: 'receptionDate',
                                    class: 'field__input--default typography--default color--default',
                                    value: parseUtcToLocalDate({
                                        date: requestDates.receptionDate,
                                        originFormat: 'DD-MM-YYYY HH:mm',
                                        finalFormat: 'DD-MM-YYYY HH:mm'
                                    }),
                                },
                                allowFilling: false
                            }"
                        />
                        <base-field
                            class="contact__body__preferencecontact"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.preferenceContact') },
                                input: {
                                    component: 'InputCalendar',
                                    id: 'preferenceContact',
                                    name: 'preferenceContact',
                                    targetClass: 'field__input--default typography--default color--default',
                                    value: parseUtcToLocalDate({
                                        date: requestDates.preferenceContact,
                                        originFormat: 'DD-MM-YYYY HH:mm',
                                        finalFormat: 'DD-MM-YYYY HH:mm'
                                    }),
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                            configs: {
                                                mode: 'dateTime',
                                                is24hr: true,
                                                minDate: new Date(),
                                                format: 'YYYY-MM-DD HH:mm'
                                            },
                                            isInline: true
                                        },
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.preferenceContact,
                                    errorOnSubmit: {
                                        show: errors.api.preferenceContact ? true : false,
                                        messages: errors.api.preferenceContact
                                    },
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            class="contact__body__address"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.address') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'address',
                                    name: 'address',
                                    class: 'field__input--default typography--default color--default',
                                    value: requestPerson.address,
                                    browserAutocomplete: 'address',
                                    isRequired: false,
                                    isMissing: errors.missing.address,
                                    errorOnSubmit: {
                                        show: errors.api.address ? true : false,
                                        messages: errors.api.address
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: permissions.allowFilling
                            }"
                        />
                        <base-field
                            v-if="isEdition"
                            class="contact__dynamic__state"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.state') },
                                input: {
                                    component: 'States',
                                    name: 'state',
                                    value: stateId,
                                },
                                allowFilling: false
                            }"
                        />
                    </div>
                </template>
            </base-card>
            <base-card class="contact__dynamic--default page--single__space">
                <template #card__title >
                    {{ $t('global.requestDetails') }}
                </template>
                <template #card__body >
                    <dynamic-fields v-if="isEdition" class="contact__dynamic" :obj="dataCampaignDefault" />
                    <basic-fields-list-handler
                        v-else
                        groupName="detail"
                    />
                </template>
            </base-card>
            <base-card class="contact__dynamic--optional">
                <template #card__title >
                    {{ $t('global.requestOptionalDetails') }}
                </template>
                <template #card__body >
                    <dynamic-fields v-if="isEdition" class="contact__dynamic" :obj="dataCampaignOptional" />
                    <basic-fields-list-handler
                        v-else
                        groupName="optional"
                    />
                </template>
            </base-card>
            <base-card class="contact__observations page--single__space">
                <template #card__title >
                    {{ $t('global.requestObservations') }}
                </template>
                <template #card__body >
                    <base-field
                        :class="[
                            'contact__body__observations',
                            { 'background--grey--light': permissions.allowFilling }
                        ]"
                        :settings="{
                            label: { class: 'field__label--hide', text: $t('global.observations') },
                            input: {
                                component: 'Textarea',
                                name: 'observations',
                                id: 'observations',
                                class: 'contact__body__observations__field typography--default color--default',
                                placeholder: $t('placeholders.observations'),
                                value: model.observations || '',
                                disableClass: 'contact__body__observations__field contact__body__observations__field--disable display--block'
                            },
                            isEdition,
                            reset,
                            allowFilling: permissions.allowFilling
                        }"
                    />
                </template>
            </base-card>
            <base-card v-if="isEdition" class="contact__calls page--single__space" :add-margins="false">
                <template #card__title >
                    {{ $t('global.calls') }}
                </template>
                <template #card__body >
                    <base-table
                        :headers="[
                            'id',
                            'beginDate',
                            'operator',
                            'state',
                            'audio',
                            'observations',
                            'details'
                        ]"
                        :list="calls"
                        model="contact"
                        :settings="{
                            component: 'RowCalls',
                            action: showDetails,
                            warning: $t('global.calls')
                        }"
                    />
                </template>
            </base-card>
        </base-form>
        <call-details
            v-if="show"
            v-bind="{
                id: callId,
                audioUrl
            }"
            @close="show = false"
        />
    </div>
</template>

<script>
// packages
import {
    ref,
    reactive,
    toRefs,
    computed,
    watch
} from '@vue/composition-api';

import { Locale } from 'v-calendar';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';
import { generateConfigsToCampaigns, useLists } from '@/hooks/get-lists';

// helpers
import { compareContacts } from '@/helpers/mixinContacts';
import { sortObjectsArray, capitalizeFirstLetter } from '@/helpers/mixinGeneral';
import { transformToInt, parseUtcToLocalDate, haveProperty } from '@/utils/';

// store
import { storePayload, useActions, mapState } from '@/hooks/use-store';

// models
import { toggleRequiredFields } from '@/models/helpers/toggle-required-fields';

// i18n
import i18n from '@/plugins/i18n';

export default {
    components: {
        ...singleStructure.components,
        BaseFieldWithUrl: () => import( /* webpackChunkName: 'BaseFieldWithUrl'  */ '@/components/bundles/fields/BaseFieldWithUrl' ),
        BaseTable: () => import( /* webpackChunkName: 'BaseTable' */ '@/components/bundles/tables/BaseTable' ),
        CallDetails: () => import( /* webpackChunkName: 'CallDetails' */ '@/components/bundles/callDetails/CallDetails' ),
        DynamicFields: () => import( /* webpackChunkName: 'DynamicFields' */ '@/components/bundles/layout/dynamicFields/DynamicFields' ),
        BasicFieldsListHandler: () => import(
            /* webpackChunkName: 'BasicFieldsListHandler' */ '@/components/bundles/layout/dynamicFields/BasicFieldsListHandler'
        ),
        WidgetButton: () => import( /* webpackChunkName: 'WidgetButton' */ '@/components/bundles/layout/widget/options/types/WidgetButton' ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        ButtonWithIcon: () => import( /* webpackChunkName: 'ButtonWithIcon' */ '@/components/bundles/buttons/BaseButtonWithIcon' ),
        BaseField: () => import( /* webpackChunkName: 'BaseField'  */ '@/components/bundles/fields/BaseField' ),
        BaseCardOption: () => import( /* webpackChunkName: 'BaseCardOption' */ '@/components/bundles/cards/imports/contacts/BaseCardOption' ),
        /* eslint-disable max-len */
        IconSelectEntities: () => import( /* webpackChunkName: 'IconSelectEntities' */ '@/components/bundles/layout/images/icons/IconSelectEntities' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props ) {
        const stateId = ref( 1 );
        const campaign = ref({ });
        const campaignId = ref( '' );
        const requestDates = ref({ });
        const requestPerson = ref({ });
        const dataCampaignDefault = ref({ });
        const dataCampaignOptional = ref({ });
        const calls = ref( [] );
        const recordedCalls = ref( [] );
        const recordingsDrop = ref( [] );
        let callStates = [];
        let requestId = '';
        const modal = reactive({
            showDuplicateCall: false,
            associateRecording: {
                show: false,
                type: null
            }
        });

        // store
        const { actions } = useActions();

        // obtenção da store errors & trigger
        const { errors, reset } = storePayload();

        // obtenção das listagens
        const { campaigns, order } = useLists( generateConfigsToCampaigns( !props.isEdition ) );

        // estruturação da informação proveniente da API, de forma
        // a ser mais fácil a sua utilização no componente.
        const structureData = newModel => {
            // se não exister novo model,
            // não é necessário executar o resto do código.
            if ( !Object.keys( newModel ).length )
                return;

            // obtenção do estado da chamada
            stateId.value = newModel.state.id;

            // obtenção da campanha associada ao pedido de contacto
            campaign.value = newModel.campaign;
            campaignId.value = newModel?.campaign.id || '';

            // obtenção dos dados do pedido de contacto
            // TODO: Avaliar porque que estas variaveis têm de ficar assim e repotar a pedroabrunhosa@zalox.com
            requestDates.value = {
                ...( newModel.request.preferenceContact && {
                    preferenceContact: newModel.request.preferenceContact.date
                }),
                ...( newModel.receptionDate && {
                    receptionDate: newModel.receptionDate
                })
            };

            // obtenção dos dados da pessoa do pedido de contacto
            requestPerson.value = {
                ...newModel.request.person,
                ...( newModel.request.person.addresses && {
                    address: newModel.request.person.addresses[0].address
                })
            };

            requestPerson.value.contacts.sort( compareContacts );

            // obtenção dos dados relativos a campanha
            dataCampaignDefault.value = newModel.request.information.data;
            dataCampaignOptional.value = newModel.request.information.optional;

            // obtenção dos dados das chamadas
            calls.value = newModel.contacts.calls.map( call => ({
                ...call,
                beginDate: parseUtcToLocalDate({
                    date: call.beginDate,
                    originFormat: 'DD-MM-YYYY HH:mm:ss',
                    finalFormat: 'DD-MM-YYYY HH:mm:ss'
                })
            }) );

            // obtenção dos dados das chamadas e
            // criação do array de chamadas e gravações a ser usado na drop de associação de gravações
            newModel.contacts.calls.forEach( call => {
                recordedCalls.value.push({
                    id: call.id,
                    date: call.beginDate,
                    operator: call.operator,
                    audio: call.audioUrl ?? null
                });
            });

            // obtenção dos estados das chamadas
            callStates = newModel.contactCallStates;

            // obtenção do id do pedido
            requestId = newModel.id;
        };

        useData( props, structureData );
        const payload = mapState({ module: 'storePayload', key: 'payload' });

        const state = reactive({
            call: {
                type: '',
                states: {
                    all: callStates,
                    drop: []
                }
            },
            showCall: {
                rescheduling: false
            },
            drop: {
                active: true,
                value: 0
            },
            associateCall: payload.value.call,
            id: requestId,
            dateFormat: 'YYYY-MM-DD HH:mm'
        });

        // Definição dos dados relativos ao modal de atualização de contacto.
        const updateContacts = reactive({
            modal: {
                show: false
            },
            types: [
                { value: 'phone', label: capitalizeFirstLetter( i18n.t( 'global.phone' ) ) },
                { value: 'email', label: capitalizeFirstLetter( i18n.t( 'global.email' ) ) }
            ]
        });
        // watcher nos valores do payload
        watch( () => payload.value,
            value => {
                // se existir o campo de chamada ( key = "call" ) atribui o valor à variavel state.associateCall
                // que é usada para definir a permissão de edição da drop de gravações
                state.associateCall = value.call ? value.call : '';

                // preenchimento da drop de gravações sem o valor da chamada selecionada na drop a cima ( drop das chamadas )
                // para não permitir associar chamadas a si mesma
                recordingsDrop.value = recordedCalls.value.filter(
                    element => transformToInt( element.id ) !== transformToInt( state.associateCall ) && element.audio
                ).map( recording => ({
                    value: recording.id,
                    label: `${recording.id} - ${recording.date.split( /(\s+)/ )[0]}`
                }) );

                // Se o modal de associação de gravação estiver aberto e
                // se o tipo de importação for diferente de 'recordings',
                // define o tipo de importação consoante exista ou não
                // 'resources' no payload
                if ( modal.associateRecording.show ) {
                    if ( modal.associateRecording.type !== 'recordings' )
                        modal.associateRecording.type = ( haveProperty( value, 'resources' ) ) ? 'file' : null;
                }
            });

        // definição das settings
        const callDetailsSettings = reactive({
            show: false,
            callId: null,
            audioUrl: null
        });

        /**
         * [method]
         * Mostrar os detalhes da chamada.
         *
         * @param callId
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const showDetails = ({ callId, audioUrl }) => {
            callDetailsSettings.show = true;
            callDetailsSettings.callId = callId;
            callDetailsSettings.audioUrl = audioUrl;
        };

        watch( () => callDetailsSettings.show,
            show => {
                document.body.style.overflow = ( show ) ? 'hidden' : 'auto';
            });

        /**
         * [method]
         * Toggle da modal proveninente do widget.
         *
         * @since 1.1.2
         * @category Method
         *
        */
        const toggleModal = () => {
            modal.showDuplicateCall = !modal.showDuplicateCall;

            // bloqueia a barra de adição / edição
            actions( 'controlActionBar', { value: modal.showDuplicateCall });

            // Caso acção seja abrir a modal é adicionado a informação ao payload.
            // Caso acção seja fechar a modal, é removido todo o payload da store.
            if ( modal.showDuplicateCall ) {
                actions( 'registerField', { name: 'requestId', value: state.id });
                actions( 'registerField', { name: 'id', value: state.id });
            } else
                actions( 'resetState', false );
        };
        /**
         * [method]
         * Toggle da modal de associar gravações proveninente do widget.
         *
         * @since 1.1.2
         * @category Method
         *
        */
        const toggleAssociateRecordingModal = () => {
            modal.associateRecording.show = !modal.associateRecording.show;
            modal.associateRecording.type = null;

            // bloqueia a barra de adição / edição
            actions( 'controlActionBar', { value: modal.associateRecording.show });
        };

        // preenchimento da drop de chamadas
        const callsDrop = ref( recordedCalls.value.map(
            call => ({
                value: call.id,
                label: `${call.id} - ${parseUtcToLocalDate({ date: call.date, originFormat: 'DD-MM-YYYY HH:mm:ss', finalFormat: 'DD-MM-YYYY HH:mm:ss' })} - ${call?.operator?.name}`
            })
        ) );

        /**
         * [method]
         * Toggle da modal do widget de atulizar contacto.
         *
         * @since 1.1.2
         * @category Method
         * @autor Jorrge Monteiro
         *
        */
        const toggleUpdateContactModal = () => {
            updateContacts.modal.show = !updateContacts.modal.show;

            // bloqueia a barra de adição / edição
            actions( 'controlActionBar', { value: updateContacts.modal.show });

            // Caso acção seja abrir a modal é adicionado a informação ao payload.
            // Caso acção seja fechar a modal, é removido todo o payload da store.
            if ( updateContacts.modal.show ) {
                actions( 'registerField', { name: 'primary', value: true });
                actions( 'registerField', { name: 'id', value: state.id });
            } else
                actions( 'resetState', false );
        };

        /**
         * [computed]
         * Obtenção da data actual.
         *
         * @since 1.0.0
         * @category Computed
         *
        */
        const getDate = computed( () => {
            // trigger para actualizar
            // a data.
            if ( !state.showCall.rescheduling )
                return null;

            const time = 1000 * 60 * 5; // transform em ms
            const date = new Date();
            return new Date( date.getTime() + time - ( date.getTime() % time ) );
        });
        /**
         * [computed]
         * Transformação da data para o formato ISO.
         *
         * @since 1.0.0
         * @category Computed
         * @autor Tiago Martinho
         *
        */
        const getDateISO = computed( () => {
            const date = new Date( getDate.value );
            return new Date( date.getTime() - ( date.getTimezoneOffset() * 60000 ) ).toISOString();
        });

        /**
         * Escolha do tipo de estado.
         * A escolhe poderá ser feita entre sucesso e insucesso.
         * A apartir do tipo de estado é gerado os valores da drop.
         *
         * @since 1.0.0
         * @category Method
         *
        */
        let states = [];
        const chooseTypeOfState = ( type = 'successful' ) => {
            state.call.type = type;
            const statesByType = state.call.states.all.filter( ({ name }) => name === `Call ${type}` );
            state.call.states.drop = statesByType[0].states.map( ({ id, description }) => ({ value: id, label: description }) );
            // ordenar drop
            sortObjectsArray( state.call.states.drop );
            states = state.call.states.drop;
            // se só houver 1 estado, é definido automaticamente esse.
            switch ( states.length ) {
                case 1:
                    actions( 'registerField', { name: 'stateId', value: states[0].value });
                    state.drop.value = states[0].label;
                    state.drop.active = false;
                    break;
                default:
                    actions( 'deleteField', { name: 'stateId' });
                    state.drop.value = 0;
                    state.drop.active = true;
                    break;
            }

            // caso o tipo seja re-agendar
            // é necessário apresentar o calendário & a input da hora
            // e também adicionar o campo como obrigatório.
            state.showCall.rescheduling = ( type === 'rescheduling' );

            if ( state.showCall.rescheduling ) {
                const locale = new Locale();
                actions( 'registerField', { name: 'rescheduleTo', value: locale.format( getDate.value, state.dateFormat ) });
            }

            toggleRequiredFields( 'resolveCall', { field: 'rescheduleTo', isRequired: state.showCall.rescheduling });
        };
        /**
        * [method]
        *
        * @param {Object} data
        * @since 1.0.0
        * @category Method
        *
        */
        const handlerCall = {
            new: data => {
                calls.value = data.map( call => ({
                    ...call,
                    beginDate: parseUtcToLocalDate({
                        date: call.beginDate,
                        originFormat: 'DD-MM-YYYY HH:mm:ss',
                        finalFormat: 'DD-MM-YYYY HH:mm:ss'
                    })
                }) );
                // reset de todos os dados da model de re-tipificação para default
                state.showCall.rescheduling = false;
                states = [];
                state.call.states.drop = [];
                state.drop.value = 0;
                state.drop.active = true;
                state.call.type = '';
            },
            // edição das observações internas
            edit: data => {
                calls.value.forEach( call => {
                    if ( call.id === data.id )
                        call.observations = data.contactRequest.internalObservations;
                });
            }
        };

        /**
        * [method]
        *
        * @param {Object} callId
        * @since 1.2.3
        * @category Method
        *
        */
        const callHasAudio = callId => {
            const getCall = calls.value.find( call => call.id === transformToInt( callId ) );

            return ![ undefined, null ].includes( getCall.audioUrl );
        };

        // store
        const store = reactive({
            blocks: mapState({ module: 'storePayload', key: 'blocks' }),
            payload: mapState({ module: 'storePayload', key: 'payload' })
        });

        const loading = mapState({ module: 'storePayload', key: 'loading' });
        // listener para quando existe
        // update de algum bloco do modelo.
        watch( () => store.blocks,
            newBlocks => {
                if ( Object.keys( newBlocks ).length )
                    handlerCall[newBlocks.call.type]( newBlocks.call.data );
            });

        // obtenção do trigger
        const trigger = mapState({ module: 'storePayload', key: 'trigger' });

        // validação de quando o trigger é activo
        // de forma a fechar a modal.
        watch( () => trigger.value,
            newTrigger => {
                if ( newTrigger ) {
                    modal.show = false;
                    updateContacts.modal.show = false;
                }
            });

        // No modal de alteração de contacto, o valor do campo 'tipo' é observado
        // e sempre que mudar, faz reset à obrigatoriedade dos campos que dependem.
        // do tipo e coloca apenas o campo que foi escolhido como obrigatório
        watch( () => store.payload.type,
            newType => {
                if ( newType ) {
                    const fields = [ 'phone', 'email' ];

                    // Eliminar obrigatoriedade e valores de todos os campos que dependem do type.
                    fields.forEach( field => {
                        toggleRequiredFields( 'contact', { field, isRequired: false, isRequiredOnEdit: false });
                        actions( 'deleteField', { name: field });
                    });

                    // Coloca como obrigatório o campo escolhido na drop do tipo.
                    toggleRequiredFields( 'contact', { field: newType, isRequired: true, isRequiredOnEdit: true });
                }
            });

        watch( () => store.payload,
            newPayload => {
                if ( haveProperty( newPayload, 'campaignId' ) )
                    campaignId.value = newPayload.campaignId;
            });

        watch( () => trigger.value,
            newTrigger => {
                if ( newTrigger )
                    modal.showDuplicateCall = false;
            });
        // close import contacts modal on submit
        watch( () => modal.associateRecording.show,
            newShow => {
                if ( newShow ) {
                    const formInterval = setInterval( () => {
                        const formModal = document.getElementById( 'associateModal' );
                        if ( formModal ) {
                            formModal.addEventListener( 'submit', () => {
                                const listener = setInterval( () => {
                                    const storeResponse = mapState({ module: 'storePayload', key: 'response' });
                                    if ( storeResponse.value.has && storeResponse.value.type === 'success' ) {
                                        modal.associateRecording.show = false;
                                        clearInterval( listener );
                                    }
                                }, 500 );
                            });
                            clearInterval( formInterval );
                        }
                    }, 200 );
                } else
                    actions( 'resetPayload' );
            });

        // Se a opção de importação for através do formulário,
        // a key 'resources' é apagada do payload caso exista e
        // são atualizados os campos obrigatórios.
        watch( () => modal.associateRecording.type,
            newType => {
                if ( newType === 'recordings' ) {
                    actions( 'deleteField', { name: 'resources' });
                    toggleRequiredFields( 'associateRecordings', { field: 'recording', isRequired: true });
                    toggleRequiredFields( 'associateRecordings', { field: 'resources', isRequired: false });
                }
            });

        return {
            stateId,
            campaign,
            requestDates,
            requestPerson,
            dataCampaignDefault,
            dataCampaignOptional,
            calls,
            showDetails,
            ...toRefs( callDetailsSettings ),
            ...toRefs( state ),
            ...toRefs( store ),
            updateContacts,
            modal,
            toggleModal,
            toggleUpdateContactModal,
            toggleAssociateRecordingModal,
            chooseTypeOfState,
            getDate,
            getDateISO,
            errors,
            reset,
            loading,
            callsDrop,
            recordingsDrop,
            callHasAudio,
            parseUtcToLocalDate,
            campaigns,
            campaignId,
            order
        };
    }
};
</script>

<style lang="scss">
    .contact {
        margin-bottom: 60px;
        &--space {
            margin: 30px 0;
        }
        &__body {
            grid-template-columns: repeat( 4, 1fr );
            row-gap: 40px;
            &__campaign,
            &__holder,
            &__address {
                grid-column: 1 / 3;
            }
            &__contact-person {
                grid-column: 3 / -1;
            }
            &__contacts {
                &__first{
                    grid-column: 1 / 2;
                }
            }
            &__observations {
                @include rounded-corner( 19px );
                &__field {
                    height: 370px;
                    &--disable {
                        padding-top: 10px;
                    }
                }
            }
        }
        &__dynamic {
            grid-template-columns: repeat( 3, 1fr );
            row-gap: 40px;
        }
    }
    .call {
        &__modal {
            &--transition {
                &-enter-active, &-leave-active {
                    height: 412px;
                    opacity: 1;
                    overflow: hidden;
                    @include transition( height .3s ease-in-out, opacity .2s ease-in-out );
                }
                &-enter, &-leave-to {
                    height: 0;
                    opacity: 0;
                    @include transition( height .3s ease-in-out .2s, opacity .3s ease-in-out );
                    will-change: height, opacity;
                }
            }
            &__header {
                @include typography-specs( 25px, 33px, 700 );
            }
            &__content {
                max-width: 480px;
            }
            &__body {
                margin-top: 20px;
            }
            &__input {
                &--new-contact {
                    margin: 25px 0;
                }
            }
            &__icons {
                justify-content: center;
                margin-bottom: 45px;
                &__button {
                    @include transition( transfrom .3s ease-in-out );
                    will-change: transform;
                    &:active {
                        @include transform( scale( .8 ) );
                    }
                }
            }
            &__icon {
                @include transition( fill .3s ease-in-out );
                will-change: fill;
                &--reschedule {
                    margin: 0 20px;
                    &--active {
                        .circle {
                            fill: $color-green;
                        }
                        .path {
                            fill: $color-white;
                        }
                    }
                    .circle, .path {
                        @include transition( fill .3s ease-in-out );
                        will-change: fill;
                    }
                }
                &--green {
                    fill: rgba( $color-green, .6 );
                    &:hover {
                        fill: $color-green;
                        & .hand {
                            @include animation( thumbs-up .6s cubic-bezier( .73, .04, 1, .3 ) );
                        }
                    }
                    &--active {
                        fill: $color-green;
                    }
                }
                &--red {
                    fill: rgba( $color-red, .6 );
                    &:hover {
                        fill: $color-red;
                        & .hand {
                            @include animation( thumbs-down .6s cubic-bezier( .73, .04, 1, .3 ) );
                        }
                    }
                    &--active {
                        fill: $color-red;
                    }
                }
            }
            &__warning {
                margin-bottom: 20px;
                @include typography-specs( 16px, 20px );
            }
        }
    }
    .associate--call{
        margin-bottom: 32px;
        input, svg{
             z-index: 6;
        }
        .field__autocomplete__options{
            z-index: 5;
        }
        &__file {
            margin: 20px auto;
        }
    }
    .modal {
        &--update-contact {
            &__content {
                max-width: 480px;
            }
            &__phone, &__email {
                margin-top: 25px;
            }
        }
        &--associate-recordings {
            &__content {
                max-width: 600px;
            }
            &__options {
                width: 100%;
                &__content {
                    gap: 32px;
                    flex-wrap: wrap;
                    justify-content: center;
                }
                &__title {
                    @include typography-specs( 25px, 29px, 700 );
                    width: 100%;
                    margin-bottom: 50px;
                    text-align: center;
                }
            }
        }
    }
</style>